import { Dayjs } from 'dayjs';

import { SearchFormFieldEnum } from './searchFormField.types';

export type SearchQueryCriteriaValueType = string | number | string[] | Dayjs;

export type SearchQueryCriteriaType = {
  field: SearchFormFieldEnum;
  value: SearchQueryCriteriaValueType;
  operator?: CriteriaOperatorEnum;
  type?: CriteriaTypeEnum;
};

export type SearchQueryRequestType = {
  criteria: SearchQueryCriteriaType[] | [];
  sort: { field: string; order: string }[] | [];
  from: number;
  max: number;
};

export type NoteType = {
  id: number;
  createdBy: string;
  createdDate: number;
  lastModifiedBy: string;
  lastModifiedDate: number;
  content: string;
};

export type UserType = {
  id: number;
  firstName: string;
  lastName: string;
};

export type CoordinatorType = {
  id: number;
  firstName: string;
  lastName: string;
};

export type BackOfficeType = {
  id: number;
  firstName: string;
  lastName: string;
};

export type RecruiterType = {
  id: number;
  firstName: string;
  lastName: string;
};

export type InterviewerType = {
  id: number;
  firstName: string;
  lastName: string;
};

export type ClientEmployeeType = {
  uuid: string;
  firstName: string;
  lastName: string;
};

export type LanguageType = {
  language: string;
  level: LanguageLevelEnum | string;
};

export enum LanguageLevelEnum {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
  NATIVE = 'Native',
  UNKNOWN = 'Unknown',
}

export type DictionaryType = {
  id: number;
  value: string;
};

export enum CriteriaOperatorEnum {
  EQ = 'EQ',
  LT = 'LT',
  LE = 'LE',
  GT = 'GT',
  GE = 'GE',
  LK = 'LK',
  IN = 'IN',
}

export enum CriteriaTypeEnum {
  MUST = 'MUST',
  SHOULD = 'SHOULD',
}

export enum ContractTypeEnum {
  B2B = 'B2B',
  PERMANENT = 'Permanent',
  CONTRACT_OF_MANDATE = 'Contract of mandate',
  CONTRACT_OF_COMMISSION = 'Contract of comission',
  UNKNOWN = 'Unknown',
}

export enum RemotePreferenceEnum {
  STATIONARY = 'Stationary',
  REMOTE_ONLY = 'Remote only',
  PARTIALLY_REMOTE = 'Partially remote',
  UNKNOWN = 'Unknown',
}

export enum PriorityEnum {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
}

export enum HistoryEntryEnum {
  STATUS = 'STATUS',
  RESPONSIBLE = 'RESPONSIBLE',
  PERFECT_MATCH = 'PERFECT_MATCH',
}

export enum ReminderTypeEnum {
  SLACK = 'slack',
  EMAIL = 'email',
}

export enum ReminderObjectClassEnum {
  CANDIDATE = 'Candidate',
}

export enum LevelEnum {
  TRAINEE = 'Trainee',
  JUNIOR = 'Junior',
  MID = 'Mid',
  SENIOR = 'Senior',
  EXPERT = 'Expert',
}

export type StatusType = {
  actionRequired: boolean;
  countedAsCvSent: boolean;
  id: number;
  name: string;
  responsibility: string;
  daysToReminder?: number | null;
};

export enum AttachementTypeEnum {
  HR_INTERVIEW = 'HR_INTERVIEW',
  TECHNICAL_INTERVIEW = 'TECHNICAL_INTERVIEW',
  OTHER = 'OTHER',
}
